import { useState } from "react";
const REFUND_TERMS = {
  plan: "refunds are only available on a written request to support@deferally.com within 30 days of my first subscription payment, annual plans are refunded minus one month at the monthly rate, and payment processing fees are not refunded.",
  planCrm: "refunds are only available on a written request to support@deferally.com within 30 days of my first subscription payment, annual plans are refunded minus one month at the monthly rate, the one-time CRM add-on is non-refundable once setup begins, and payment processing fees are not refunded.",
  crm: "this one-time CRM add-on is non-refundable once setup begins. Before setup, a refund can be requested in writing to support@deferally.com within 30 days of purchase, less payment processing fees.",
};


const box = (dark) => `flex items-start gap-2.5 text-xs leading-relaxed cursor-pointer select-none rounded-xl border p-3 ${dark ? "bg-white/5 border-white/10 text-white/70" : "bg-[#FAFAFA] border-black/5 text-ally-slate"}`;

// Both boxes must be ticked; onChange receives true only when Refund Policy AND Terms are accepted.
export function RefundPolicyCheck({ onChange, kind = "plan", dark = false, testid = "refund-policy-check" }) {
  const [refund, setRefund] = useState(false);
  const [terms, setTerms] = useState(false);
  const set = (r, t) => { setRefund(r); setTerms(t); onChange(r && t); };
  return (
    <div className="mt-4 space-y-2">
    <label data-testid={`${testid}-terms`} className={box(dark)}>
      <input type="checkbox" checked={terms} onChange={(e) => set(refund, e.target.checked)} data-testid={`${testid}-terms-box`}
        className="mt-0.5 h-4 w-4 shrink-0 accent-[#FF0083] cursor-pointer" />
      <span>
        I have read and agree to the{" "}
        <a href="/terms" target="_blank" rel="noopener noreferrer" data-testid={`${testid}-terms-link`} className="font-bold text-ally-pink underline">Terms of Service</a>
        , including that DeferAlly is software and not a Qualified Intermediary.
      </span>
    </label>
    <label data-testid={testid} className={box(dark)}>
      <input type="checkbox" checked={refund} onChange={(e) => set(e.target.checked, terms)} data-testid={`${testid}-box`}
        className="mt-0.5 h-4 w-4 shrink-0 accent-[#FF0083] cursor-pointer" />
      <span>
        I have read and agree to the{" "}
        <a href="/refund-policy" target="_blank" rel="noopener noreferrer" data-testid={`${testid}-link`} className="font-bold text-ally-pink underline">Refund Policy</a>.
        {" "}I understand {REFUND_TERMS[kind]}
      </span>
    </label>
    </div>
  );
}
